import { RootState } from 'handlers';

export const getUpcomingLoanPayments = (state: RootState) => state.upcomingLoanPayments;
